import { useAuthState } from '@percent/cause-dashboard/common/hooks/useAuthState/useAuthState'
import { isOfferAllowedInCountry } from '@percent/cause-dashboard/common/utility/productOffers/productOffers'
import { useMetaOfferAllowedCountries } from '@percent/cause-dashboard/storyblok/product-offers/useMetaOfferAllowedCountries'

export function useMetaOfferAllowedInCountry(enabled: boolean): boolean {
  const { authState } = useAuthState()
  const { allowedCountries, loading, error } = useMetaOfferAllowedCountries(enabled)

  if (!enabled || loading || error || !allowedCountries) {
    return false
  }

  return isOfferAllowedInCountry(authState, allowedCountries)
}
